import { keys, values, orderBy, groupBy } from 'lodash';

export function selectedAssignmentId(state) {
  return state.selectedAssignmentId;
}

export function assignments(state) {
  return state.assignments;
}

export function assignmentList(state) {
  return orderBy(values(state.assignments), ['updated_at'], ['desc']);
}

export function assignmentIds(state) {
  return keys(state.assignments);
}

export function classAssignments(state, getters) {
  return groupBy(getters.assignmentList, 'class_id');
}

export function teacherAssignmentStats(state) {
  return state.teacherAssignmentStats;
}

export function selectedCardForNewAssignment(state) {
  return state.selectedCardForNewAssignment;
}



// WEBPACK FOOTER //
// ./src/app/assignments/store/getters.js